import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Select from 'react-select';
import AssignmentIcon from '@mui/icons-material/Assignment';
import {
    ResponsiveContainer,
    ComposedChart,
    Line,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from 'recharts';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import Checkbox from "../../../../common/Checkbox";
import Moment from 'moment';
import "moment/locale/ko";
import { useNavigate, useLocation } from "react-router-dom";

const MachineToolUsedStatistics = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [tabID, setTabID] = useState('1');
    const [gridWidth, setGridWidth] = useState('450px');
    const [graphData, setGraphData] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        start_date: Moment().format("YYYY-MM-01"),
        end_date: appStore.YYYY_MM_DD(),
        machine_id: "", // 설비
        machine_type: "",
    });
    const [graphTitle, setGraphTitle] = useState('');
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        tool_no: true,
        usage_time: false,
        dis_usage_time: true,
    });
    const [machineInfo, setMachineInfo] = useState([]); // 설비 리스트
      const [machineOption, setMachineOption] = useState([]);
    const [FauncYN, setFauncYN] = useState("N");

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
      // 아래의 변수가 변경되면 실행된다. -> MenuID 가 0이면 아직 권한 체크가 되지 않았으므로, 권한 체크 후 조회.
      setKeyword({
          ...keyword,
      });

      setGridWidth('450px');
      setColumns([
        { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
        { field: 'tool_no', headerName: '공구번호', width: 120, headerAlign: 'center', align:'right'},
        { field: 'usage_time', headerName: '사용시간', width: 150, headerAlign: 'center', align:'right' },
        { field: 'dis_usage_time', headerName: '사용시간', width: 180, headerAlign: 'center', align:'right' },
      ]);
      
      setColumnVisibilityModel({
        id: false,
        tool_no: true,
        usage_time: false,
        dis_usage_time: true
      });
    }, [keyword.start_date, keyword.end_date, keyword.machine_id]);

    useEffect(() => {
      if (String(MenuID) !== String(0) && MenuID != null) {
        handleInitSelect();
        handleMainView(); // 빈 함수였던 handleView 대신 화면 진입 시 바로 조회되도록 수정
      }
    }, [MenuID]);
    
    const handleInitSelect = () => {
        let type_list = "";
        axios
        .get("/api/SelectCommon/MachineList")
        .then((response) => {
          const optionArray = response.data.map((item) => ({
            value: item.machine_id,
            label: item.machine_name,
          }));
          optionArray.unshift({ value: "", label: "전체" });
          setMachineOption([...new Set(optionArray.map(JSON.stringify))].map(JSON.parse));

          const full_array = [];
          response.data.forEach((item) => {
            if (String(item.machine_type) === "1") {
              setFauncYN("Y");
            }
            full_array.push({
              machine_id: item.machine_id,
              machine_type: item.machine_type,
              machine_name: item.machine_name,
            });
            if (type_list === "") {
              type_list = String(item.machine_type);
            } else {
              type_list = String(type_list) + "," + String(item.machine_type);
            }
          });
          setMachineInfo(full_array);
        })
        .catch((error) => {
          console.log(error);
        });

        setColumns([
          { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
          { field: 'tool_no', headerName: '공구번호', width: 120, headerAlign: 'center', align:'right'},
          { field: 'usage_time', headerName: '사용시간', width: 150, headerAlign: 'center', align:'right' },
          { field: 'dis_usage_time', headerName: '사용시간', width: 180, headerAlign: 'center', align:'right' },
        ]);
    };

    const handleInit = () => {
        setTabID('');
    };

    // Grid 데이터 조회
    const handleMainView = () => {
      if(keyword.start_date.length === 10 && keyword.end_date.length === 10 && keyword.start_date >= '2025-01-01' && keyword.end_date >= '2025-01-01' && keyword.start_date <= '2049-12-31' && keyword.end_date <= '2049-12-31'){
        axios.get('/api/p/MachineToolUsedStatistics/List',
            {
            params : {
                start_date : keyword.start_date,
                end_date : keyword.end_date,
                machine_id : keyword.machine_id
            }
        },
        { withCredentials: true }
        )
        .then((response) => { 
            // 1. 그리드용 데이터 셋팅
            const array = response.data
            .sort((a, b) => Number(b.usage_time) - Number(a.usage_time))
            .map((item, index) => {
                const totalMin = Number(item.usage_time);
                const h = Math.floor(totalMin / 60);
                const m = totalMin % 60;
                
                // 분(m)이 0일 경우 시간만 표기하도록 조건 추가
                const gridTimeString = h > 0 
                    ? (m > 0 ? `${h}시간 ${m}분` : `${h}시간`) 
                    : `${m}분`;

                return {
                    id: item.id, 
                    tool_no: item.tool_no + '번',
                    usage_time: item.usage_time,
                    dis_usage_time: gridTimeString
                };
            });
            setRows(array);

            // 2. 그래프용 데이터 셋팅
            const graphArray = response.data.map((item) => {
                const totalMin = Number(item.usage_time);
                const h = Math.floor(totalMin / 60); 
                const m = totalMin % 60;             
              
                // 분(m)이 0일 경우 시간만 표기하도록 조건 추가
                const timeString = h > 0 
                    ? (m > 0 ? `${h}시간 ${m}분` : `${h}시간`) 
                    : `${m}분`;

                return {
                    name: `${item.tool_no}번`, 
                    usage_time: totalMin,       
                    display_time: timeString    
                };
            });
            setGraphData(graphArray);
        })
        .catch((error) => {
            appStore.capture();
        });
      }
    }

    const onDateChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSelectChange = (type, value) => {
        var nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const handleTabID = (event, newTabID) => {
        setTabID(newTabID);
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '145px', boxShadow: 'none' } }>
            <div className="menu-action" style={ { height: '55px' } }>
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleMainView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword" style={ { paddingTop:'5px' } }>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" style={ { width: '80px', paddingTop: '7px', fontWeight: 'bold' } }>
                            설비
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select
                                className="menu-keyword-sub-keyword-select"
                                placeholder="설비"
                                onChange={(e) => onSelectChange("machine_id", e.value)}
                                // 타입을 강제로 문자열로 맞춰서 비교하도록 수정
                                value={machineOption.filter((option) => String(option.value) === String(keyword.machine_id))}
                                options={machineOption}
                                noOptionsMessage={() => "조회되는 항목 없음"}
                              />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" style={ { width: '100px', fontWeight: 'bold' } }>
                            조회기간
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px' } }>
                            <input type="date" value={keyword.start_date} name="start_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                        <div className="menu-keyword-sub-title" style={ { textAlign: 'center', width: '50px' } }>
                            ~
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px'} }>
                            <input type="date" value={keyword.end_date} name="end_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid" style={ { top: '147px' } }>
                <div style={{ float: 'left', width: 'calc('+gridWidth+' - 50px)' }}>
                    <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 287px)', fontSize: '17px' } }>
                        <DataGrid
                          className="grid_main"
                          rows={rows}
                          columns={columns}
                          getRowId={(row) => `${row.id}`}
                          slots={{
                              noRowsOverlay: GridNoRow,
                          }}
                          columnVisibilityModel={columnVisibilityModel}
                          AlternatingRowBackground="LavenderBlush"
                          rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                </div>
                <div style={{ float: 'right', width: 'calc(100% - ('+gridWidth+' + 50px))', paddingRight:'50px'}}>
                    <h3 style={ { margin: '0px', textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', fontSize: '24px' } }>{graphTitle}</h3>
                    <div style={{ width: '100%', height: 'calc(100vh - 350px)' }}>
                        {graphData.length > 0 ? 
                            <>
                                <ResponsiveContainer>
                                    <ComposedChart width={'calc(100% - '+gridWidth+')'} height={'calc(100vh - 350px)'} data={graphData} margin={{ top: 5, right: 5, bottom: 0, left: 50 }}>
                                        <CartesianGrid stroke="#f5f5f5" />
                                        <XAxis dataKey="name" />
                                        <YAxis tickFormatter={tick => { return tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }} />
                                        <Tooltip formatter={(value, name, props) => props.payload.display_time} />
                                        <Bar dataKey={"usage_time"} name={"사용시간"} barSize={30} fill="#3D63AE" />
                                    </ComposedChart>
                                </ResponsiveContainer>
                            </>
                            :
                            <>
                                <h3 style={ { margin: '0px', textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', fontSize: '24px' } }>조회된 데이터가 없습니다.</h3>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MachineToolUsedStatistics;